import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types/swagger';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_LINK_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_POST_ASPECT_CALL, KEY_POST_ASPECT_GENERATE } from '../constants';
import { MOCK_RESPONSE_POST_ASPECT_GENERATE } from '../mocks';

export type RequestPostAspectGenerate = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_LINK_PATH_KEY
>['request']['body'];

export type ResponsePostAspectGenerate = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_LINK_PATH_KEY
>['response']['body'];

export type CallParamsPostAspectGenerate = RequestPostAspectGenerate & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostAspectGenerate = ResponsePostAspectGenerate;

type CallErrorPostAspectGenerate = {
  message: string;
  code: number;
};

type CallSelectorsPostAspectGenerate = unknown;

export const postAspectGenerateCall = createGeneralCall<
  CallParamsPostAspectGenerate,
  CallResponsePostAspectGenerate,
  CallErrorPostAspectGenerate,
  CallSelectorsPostAspectGenerate
>({
  id: KEY_POST_ASPECT_GENERATE,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_ASPECT_CALL(org as unknown as string);
  },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_ASPECT_GENERATE : undefined,
});
